import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnlinePaymentEnum } from 'src/app/models/Payment/OnlinePaymentType.enum';
import { environment } from 'src/environments/environment';
export interface DialogData {
  registerObject: any
  userEmail: string
  name: string
  isRenew:boolean
  checkOutRedirectUrl:string
}

@Component({
  selector: 'app-efinance-form',
  templateUrl: './efinance-form.component.html'
})
export class EfinanceFormComponent implements OnInit {
  PaymentObj: any
  paymentProvider = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<EfinanceFormComponent>,
  ) { }

  ngOnInit(): void {
    this.PaymentObj = {
      userEmail: this.data.userEmail,
      name: this.data.name,
      checkOutRedirectUrl: this.data.checkOutRedirectUrl ? this.data.checkOutRedirectUrl : `${window.location.origin}/login`,
      objectId: 1,
      transactionType: "Subscribe",
      userData:this.data.registerObject,
      isRenew:this.data.isRenew

      // transactionType: PaymentType.TraineeEnrollment
    }
  }
}
